export default {"src":"/assets/_next/static/media/img-file-upload-cv-upload.41e1c853.svg","height":343,"width":441,"blurWidth":0,"blurHeight":0};